// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__bZOA7","Disabled":"Button_Disabled__eClXH"};